export default __webpack_public_path__ + "static/media/renault.6baba335.svg";